import {
    // Constants
    MOTDS_CHANGED,

    // Actions
    addError,
    addWarning,
    addSuccess,
    addInfo,
    addMessage,
    setMessages,
    setQueue,
    motdOutdated,
} from './data'

// Reducer is exposed so that we can hook it up to the store creation
export { default as toasterReducer } from './data/reducer'

// Middleware is exposed so that we can hook it up to the store creation
export { default as middleware } from './middleware'

// Constants are exposed as a way for toaster to send out information
// Way for the feauture to inform the surroundings of something that has happened
export const constants = {
    MOTDS_CHANGED, // LocalForageMiddleware
}

// Actions are exposed as a way for the feature to recieve information
// The surrounding can send in data using these actions
export const actions = {
    addError, // LoginWindow, TemporaryLaunchFrame, Backend
    addWarning, // NotifierMiddleware
    useSettingsQueue: () => setQueue('settings'), // NotifierMiddleware
    useNormalQueue: () => setQueue(), // NotifierMiddleware
    motdOutdated, // SyncMiddleware

    // Only exposed so that it can be tested in ToastTester...
    addSuccess,
    addInfo,
    addMessage,
    setMessages,
}



// WEBPACK FOOTER //
// ./src/features/Toaster/exports.js